import React from 'react';
import InquiryDetailComponent from '../../components/InquiryDetail/InquiryDetail';
import './InquiryDetail.css';

const InquiryDetail: React.FC = () => {
  return (
    <div className="inquiry-detail-page">
      <InquiryDetailComponent />
    </div>
  );
};

export default InquiryDetail;
